import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend
);

const Linea2 = ({ datos }) => {
    // La propiedad 'data' de `datos` se renombra a `datasets` para reflejar la estructura correcta
    const data = {
        labels: datos.labels,
        datasets: datos.datasets,
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            title: {
                // Se oculta el título en el gráfico, ya que lo manejas en el componente padre
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    display: true,
                    precision: 0,
                },
                grid: {
                    display: true,
                },
            },
            x: {
                ticks: {
                    autoSkip: true,
                    maxTicksLimit: 15,
                },
                grid: {
                    display: true,
                },
            },
        },
    };

    return <Line data={data} options={options} />;
};

export default Linea2;